<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Order Hub - orders in progress</h1>
        </div>
        <div class="order-prep-legend">
            <ul>
                <li><span class="legend-number">1</span> Designed</li>
                <li><span class="legend-number">2</span> Internal Proof</li>
                <li>
                    <span class="legend-number">3</span> PDF emailed (only if
                    ordered)
                </li>
                <li>
                    <span class="legend-number">4</span> PDF approved (only if
                    ordered)
                </li>
                <li><span class="legend-number">5</span> Prepped</li>
            </ul>
        </div>
        <div class="float-left">
            Actions
            <el-select
                style="width: auto"
                v-model="action.name"
                placeholder="Select Action"
                :disabled="!action.orders.length"
            >
                <el-option
                    :key="index"
                    :label="action.name"
                    :value="action.value"
                    v-for="(action, index) in actions"
                >
                </el-option>
            </el-select>
            <el-select
                style="width: auto"
                v-model="action.assignee_id"
                v-if="action.name == 'assignee'"
                placeholder="Select User"
            >
                <el-option
                    :key="user.id"
                    :label="user.name"
                    :value="user.id"
                    v-for="user in assigneeOptions"
                >
                </el-option>
            </el-select>
            <el-button @click="applyAction" :disabled="!action.orders.length"
                >Apply</el-button
            >
            <el-input
                @input="onInputSearch"
                placeholder="Search Orders..."
                style="width: 250px"
                v-model="filter.search"
            />
        </div>
        <div class="float-right">
            Filter by:
            <el-select
                @change="onChangeCorporation"
                clearable
                filterable
                placeholder="Corporation..."
                style="width: 200px; margin-right: 20px"
                v-model="filter.corporation_id"
            >
                <el-option label="Independent" value="independent" />
                <el-option
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-for="item in corporations.data"
                />
            </el-select>
            View orders assigned to
            <el-select
                @change="onChangeAssignee"
                filterable
                style="width: auto"
                v-model="assignee_id"
            >
                <el-option-group>
                    <el-option label="View All" value="View All" />
                    <el-option label="Unassigned" value="" />
                </el-option-group>
                <el-option-group>
                    <el-option
                        :key="user.id"
                        :label="user.name"
                        :value="user.id"
                        v-for="user in assigneeOptions"
                    >
                    </el-option>
                </el-option-group>
            </el-select>
        </div>
        <div class="clearfix"></div>
        <el-table
            :data="computedOrders"
            @sort-change="onSortChange"
            class="mt-20"
            ref="table"
            row-key="order.id"
            v-loading="orders.meta.loading"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column width="30">
                <template v-slot="{ row }">
                    <span
                        v-if="isOrderDue(row.order)"
                        class="el-icon-warning-outline"
                    ></span>
                </template>
            </el-table-column>
            <el-table-column
                label="Issue"
                prop="issue_month"
                sortable="custom"
                width="150"
            >
                <template v-slot="{ row }">
                    <span
                        :title="
                            isOrderDue(row.order)
                                ? 'Order updated ' +
                                  $options.filters.relative(
                                      row.order.created_at
                                  )
                                : ''
                        "
                    >
                        {{ row.order.formatted_month }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                label="Order Placed"
                prop="created_at"
                sortable="custom"
                width="180"
            >
                <template v-slot="scope">
                    {{ scope.row.order.created_at | florida_short_datetime }}
                </template>
            </el-table-column>
            <el-table-column
                label="Customer"
                prop="community"
                sortable="custom"
            >
                <template v-slot="{ row }">
                    {{ row.order.tenant.name }}
                </template>
            </el-table-column>
            <el-table-column label="Prepped" min-width="130px" width="200px">
                <div class="prep-actions" slot-scope="scope">
                    <a
                        href="#"
                        v-if="!status || !scope.row.statuses[status].hidden"
                        @click.prevent="
                            status && scope.row.statuses[status].can_edit
                                ? checkStatus(
                                      scope.row.order,
                                      status,
                                      !scope.row.statuses[status].checked
                                  )
                                : null
                        "
                        v-for="(status, i) in statuses.prepper"
                        :title="
                            status && scope.row.statuses[status].checked
                                ? $options.filters.short_datetime(
                                      scope.row.statuses[status].updated_at
                                  ) +
                                  ' - ' +
                                  data_get(
                                      scope.row.statuses[status].updater,
                                      'name'
                                  )
                                : null
                        "
                        :class="scope.row.statuses[status].class"
                    >
                        <span
                            v-if="
                                !isItemBusy(
                                    scope.row.order,
                                    'check status ' + status
                                )
                            "
                            >{{ i + 1 }}</span
                        >
                        <i class="el-icon-loading" v-else />
                    </a>
                </div>
            </el-table-column>
            <el-table-column
                v-for="status in statuses.others"
                :key="status"
                :label="getOrderStatusFullName(status)"
                width="100px"
            >
                <span
                    class="text-center w-full block"
                    slot="header"
                    slot-scope="scope"
                >
                    {{ getOrderStatusFullName(status) }}
                </span>
                <div class="text-center" slot-scope="scope">
                    <template v-if="scope.row.statuses[status].na">
                        N/A
                    </template>
                    <template v-else>
                        <template v-if="scope.row.statuses[status].checked">
                            {{
                                $options.filters.short_datetime(
                                    scope.row.statuses[status].updated_at
                                )
                            }}<br /><span class="bold">{{
                                data_get(
                                    scope.row.statuses[status].updater,
                                    "name"
                                )
                            }}</span>
                        </template>
                        <el-button
                            :data-status="status"
                            :icon="statusIcons[status]"
                            :loading="
                                isItemBusy(
                                    scope.row.order,
                                    'check status ' + status
                                )
                            "
                            :disabled="!scope.row.statuses[status].can_edit"
                            @click="
                                scope.row.statuses[status].can_edit
                                    ? checkStatus(
                                          scope.row.order,
                                          status,
                                          !scope.row.statuses[status].checked
                                      )
                                    : null
                            "
                            circle
                            size="mini"
                            v-else
                        />
                    </template>
                </div>
            </el-table-column>
            <el-table-column prop="actions" width="130px">
                <template v-slot="{ row }">
                    <el-button-group>
                        <router-link
                            :to="{
                                name: Routes.VIEW_ORDER,
                                params: { id: row.order.id },
                            }"
                            class="el-button el-button--default text-decoration-none"
                        >
                            <i class="mdi mdi-eye"></i>
                            View
                        </router-link>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :pagination="orders.meta.pagination"
            @current-change="onCurrentPageChange"
            class="mt-10"
        />
    </vue-scroll>
</template>

<script>
import { mapState } from "vuex";
import * as ApprovalStatus from "@/constants/approval-status";
import * as Statuses from "@/constants/order-statuses";
import order_status_mixin from "@/mixins/order-status";
import OrderUtils from "@/utils/order";
import * as AccountTypes from "@/constants/account-types.js";
import qs from "qs";
import backend_paginator from "@/mixins/backend-paginator";
import * as Routes from "@/constants/routes";
import Utils from "@/utils";
import auth from "@/mixins/auth";
import * as Permissions from "@/constants/permissions";
import assign_order from "@/mixins/assign-order";
import * as Roles from "@/constants/roles";

const INCLUDE =
    "statuses.updater,community.locations,community.corporation,creator,tenant,latest_status,items.sizes.size";

function getData(params = {}) {
    _.merge(params, {
        include: INCLUDE,
        pending: 1,
        rush_processing_first: 1,
        filter: {
            approval_status: ApprovalStatus.APPROVED,
        },
    });
    return axios.get(`/web-api/order?${qs.stringify(params)}`);
}

export default {
    mixins: [order_status_mixin, backend_paginator, auth, assign_order],
    beforeRouteEnter(to, from, next) {
        getData(to.query).then((response) => {
            next((vm) => {
                _.extend(
                    vm.currentQuery,
                    _.pick(to.query, ["sort_by", "sort_order", "page"])
                );
                _.extend(vm.currentQuery.filter, _.get(to, "query.filter"));
                vm.setData(response);
            });
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.orders.meta.loading = true;
        getData(to.query)
            .then((response) => {
                this.setData(response);
                next();
            })
            .finally(() => (this.orders.meta.loading = false));
    },
    data() {
        return {
            Routes,
            ApprovalStatus,
            dialogVisible: false,
            form: new Form({
                name: null,
                slug: null,
                logo: null,
                location: {
                    street: null,
                    city: null,
                    state: null,
                    zip: null,
                },
            }),
            filter: {
                created_at: null,
                search: "",
                corporation_id: null,
            },
            assignee_id: "View All",
            logo_src: null,
            editingItem: null,
            currentQuery: {
                filter: {
                    search: null,
                    created_at: null,
                },
                page: 1,
                sort_by: null,
                sort_order: "asc",
            },
            routeName: Routes.ORDER_HUB,
            orders: {
                data: [],
                meta: {
                    pagination: null,
                    loading: false,
                },
            },
            dateFilterOptions: {
                shortcuts: [
                    {
                        text: "Today",
                        onClick(picker) {
                            picker.$emit("pick", new Date());
                        },
                    },
                    {
                        text: "Yesterday",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit("pick", date);
                        },
                    },
                    {
                        text: "A week ago",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", date);
                        },
                    },
                ],
            },
            statuses: {
                prepper: [
                    Statuses.DESIGNED,
                    Statuses.INTERNAL_PROOF,
                    Statuses.EMAILED_TO_CLIENT,
                    Statuses.PDF_APPROVED,
                    Statuses.PREPPED,
                ],
                others: [
                    Statuses.WALL_POSTERS_PRINTED,
                    Statuses.WALL_POSTERS_SHIPPED,
                    Statuses.FLATS_PRINTED,
                    Statuses.FLATS_SHIPPED,
                ],
            },
            statusIcons: {
                [Statuses.WALL_POSTERS_PRINTED]: "mdi mdi-printer",
                [Statuses.WALL_POSTERS_SHIPPED]: "mdi mdi-truck",
                [Statuses.FLATS_PRINTED]: "mdi mdi-printer",
                [Statuses.FLATS_SHIPPED]: "mdi mdi-truck",
            },
            actions: [
                {
                    name: "Mark as Designed",
                    value: "designed",
                },
                {
                    name: "Mark as Proofed",
                    value: "internal proof",
                },
                {
                    name: "Mark as Emailed",
                    value: "emailed to client",
                },
                {
                    name: "Mark as Approved",
                    value: "pdf approved",
                },
                {
                    name: "Mark as Prepped",
                    value: "prepped",
                },
                {
                    name: "Assigned To",
                    value: "assignee",
                },
            ],
            action: {
                name: null,
                assignee_id: null,
                orders: [],
            },
        };
    },
    computed: {
        ...mapState({
            corporations: (state) => state.corporations,
        }),
        computedOrders() {
            return _.map(this.orders.data, (order) => {
                let statuses = {};
                _.forEach(Statuses, (status) => {
                    let status_model = order.statuses.data.find(
                        (item) => item.status === status
                    );
                    let updater = _.get(status_model, "updater", null);
                    let obj = {
                        checked: _.get(status_model, "checked", false),
                        hidden: false,
                        updater: _.get(status_model, "updater", null),
                        updated_at: _.get(status_model, "updated_at", null),
                        class: [],
                        na: false,
                        can_edit:
                            (updater && updater.id == this.auth.user.id) ||
                            (_.get(status_model, "checked", false) &&
                                this.canOverrideOrderStatus) ||
                            (!_.get(status_model, "checked", false) &&
                                this.can(Permissions.CHECK_HUB_ORDER_STATUS)),
                    };
                    if (obj.checked) {
                        obj.class.push("disabled");
                    }
                    if (!obj.can_edit) {
                        obj.class.push("not-allowed");
                    }
                    if (_.includes(this.statuses.prepper, status)) {
                        // prepper
                        obj.class.push(
                            "prepper-" +
                                (_.indexOf(this.statuses.prepper, status) + 1)
                        );
                    } else {
                        // other status
                        switch (status) {
                            case Statuses.FLATS_PRINTED:
                            case Statuses.FLATS_SHIPPED:
                                if (!order.has_flat_shipment) {
                                    obj.na = true;
                                }
                                break;
                            case Statuses.WALL_POSTERS_PRINTED:
                            case Statuses.WALL_POSTERS_SHIPPED:
                                if (!order.has_poster_shipment) {
                                    obj.na = true;
                                }
                                break;
                        }
                    }
                    statuses[status] = obj;
                });
                let hidden_statuses = [];
                if (!order.ordered_newsletter_pdf_proof) {
                    hidden_statuses.push(Statuses.PDF_APPROVED);
                }
                if (
                    !order.ordered_newsletter_pdf_proof &&
                    !order.ordered_newsletter_pdf_only
                ) {
                    hidden_statuses.push(Statuses.EMAILED_TO_CLIENT);
                }
                if (order.account_type === AccountTypes.CALENDARS_ONLY) {
                    hidden_statuses.push(Statuses.INTERNAL_PROOF);
                    hidden_statuses.push(Statuses.PREPPED);
                }
                hidden_statuses.forEach((status) => {
                    _.set(statuses, `${status}.hidden`, true);
                });
                return {
                    order,
                    statuses,
                };
            });
        },
        canOverrideOrderStatus() {
            return this.can(Permissions.OVERRIDE_ORDER_STATUS);
        },
    },
    mounted() {
        this.filter.search = _.get(this.$route, "query.filter.search", "");
        if (_.get(this.$route, "query.filter.assignee_id")) {
            this.assignee_id = parseInt(
                _.get(this.$route, "query.filter.assignee_id")
            );
            this.action.assignee_id = parseInt(
                _.get(this.$route, "query.filter.assignee_id")
            );
        } else {
            this.assignee_id = _.get(
                this.$route,
                "query.filter.assignee_id",
                "View All"
            );
            this.action.assignee_id = _.get(
                this.$route,
                "query.filter.assignee_id",
                null
            );
        }
        Vue.nextTick(() => {
            this.updateTableSorting();
        });
    },
    methods: {
        onInputSearch: _.debounce(function () {
            this.currentQuery.page = 1;
            this.currentQuery.filter.search = this.filter.search;
            this.updateRoute();
        }, 500),
        setData(response) {
            this.orders.data = response.data.data;
            this.orders.meta.pagination = response.data.meta.pagination;
        },
        isOrderDue(order) {
            return OrderUtils.isDue(order);
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.order.rush_processing) {
                if (this.isOrderDue(row.order)) {
                    return "rush-row-error";
                } else {
                    return "rush-row";
                }
            }
            if (this.isOrderDue(row.order)) {
                return "error-row";
            }
            return "";
        },
        checkStatus(order, status, isChecked = true) {
            this.addBusyItem(order, "check status " + status);
            axios
                .put(`/web-api/order/${order.id}/status?include=updater`, {
                    statuses: [
                        {
                            status,
                            checked: isChecked,
                        },
                    ],
                })
                .then((response) => {
                    //console.log(response.data);
                    order.statuses = response.data;
                    order.last_status_update = moment()
                        .utc()
                        .format("YYYY-MM-DD HH:mm:ss");
                    if (OrderUtils.isClosed(order)) {
                        Utils.arrayDelete(this.orders.data, order);
                        this.$notify.success({
                            message: `Order #${order.id} has been closed.`,
                        });
                    }
                })
                .finally(() =>
                    this.removeBusyItem(order, "check status " + status)
                );
        },
        onChangeAssignee(assignee_id) {
            if (assignee_id === "View All") {
                _.unset(this.currentQuery.filter, "assignee_id");
                this.updateRoute();
            } else {
                this.currentQuery.filter.assignee_id = assignee_id;
                this.updateRoute();
            }
        },
        onChangeCorporation(value) {
            switch (value) {
                case null:
                case "":
                    this.currentQuery.filter = _.omit(
                        this.currentQuery.filter,
                        ["corporation_id"]
                    );
                    break;
                case "independent":
                    this.currentQuery.filter.corporation_id = null;
                    break;
                default:
                    this.currentQuery.filter.corporation_id = value;
                    break;
            }
            this.updateRoute();
        },
        handleSelectionChange(val) {
            this.action.orders = val;
        },
        applyAction() {
            let vm = this;
            if (!vm.action.orders.length) {
                vm.$notify.error({
                    message: "Please select orders for apply action.",
                });
                return;
            }
            if (!vm.action.name) {
                vm.$notify.error({
                    message: "Please select action for apply action.",
                });
                return;
            }
            if (vm.action.name == "assignee" && !vm.action.assignee_id) {
                vm.$notify.error({
                    message: "Please select user for apply action.",
                });
                return;
            }
            axios
                .post("/web-api/apply-action/orders", vm.action)
                .then((response) => {
                    //console.log(response);
                    vm.updateRoute();
                    vm.$notify.success({
                        message: "Orders updated successfully.",
                    });
                })
                .catch((error) => {
                    console.log(error);
                    vm.orders.meta.loading = false;
                });
        },
    },
};
</script>

<style scoped></style>
